export class ConsumerInteractionModel {
    id: string;
    consumerID: string;
    serialNumber: string;
    requestName: string;
    requestdate: Date;
    requestStatus: string;
    scheduleTime: Date;
    userId: string;
    bulkID: string;
    requestParams: string;
}

export class ConsumerDeviceInteractionModel {
    consumerID: number;
    clientID: number;
    requestDate: Date;
    scheduleTime: Date;
    requestStatus: string;
    requestname: string;
    bulkID: string; 
    consumerName: string; 
    consumerAddres: string; 
}

export class PagedConsumerInteractionModel {

    totalPages: number;
    currentPage: number;
    pageSize: number;
    totalItems: number;
    items: ConsumerDeviceInteractionModel[] = [];
    inProgressCount: number;
    completedCount: number;
    errorCount: number;
    myInteractionCount: number;
}

export enum ConsumerInteractionType {
        GetMeterRead = "GetMeterRead",
        ResetCreditStatus = "ResetCreditStatus",
        CreditStatusAdjustment = "CreditStatusAdjustment",
        GetCreditStatus = "GetCreditStatus",
        GetTarrif = "GetTarrif",
        ChangeFDSettings = "ChangeFDSettings",
        GetFDSettings = "GetFDSettings",
        SendScreenMessage = "SendScreenMessage"
}

export enum BulkItemOptions {
    //Account
    AdjustCreditStatus = "Adjustment credit status by a value",
    ResetCreditStatus = "Reset credit status to zero",
    ChangeECLimit = "Change value of emergency credit limit",
    ApplyLoan = "Apply a loan",
    GetCreditStatus = "Get credit status",
    //Consumption & Tarrif
    GetMeterReads = "Get meter reading(s)",
    GetSupplyTarrifs = "Get supply tariff(s)",
    UpdateSupplyTarrifs = "Update supply tariff",
    GetStandingCharges = "Get standing charge value",
    UpdateStandingCharges = "Update standing charge value",
    //Device
    GetFriendlyDisconnect = "Get friendly disconnect setting",
    UpdateFriendlyDisconnectSettings = "Update friendly disconnect setting",
    SendScreenMessage = "Send screen message",
    GetConnectionStatus = "Get connection status"
}

export enum ConsumerInteractionProgressType {
    InProgress = "In Progress",
    Error = "Error",
    Completed = "Completed"
}

export enum navItemKey {
    Account = "account",
    TarrifConsumption = "tarrifAndConsumption",
    Device = "device"
};

export class StandingCharges {
    Charge: string;
    ChargeType: string;
    ChargeValue: string;
}

export class SupplyTarrif {
    tarrif: string;
    tarrifValue: string;
}

export class InteractionType {
    key: string;
    selected: boolean;
}

export class InteractionTypeModel {
    navItem: navItemKey;
    type: InteractionType;
    isGet: boolean;
    isSkipHow?: boolean;
    tag: string;
}

export class InteractionDateModel {
    date: Date;
    isScheduled: boolean;
}

export class InteractionWhoModel {
    consumerIds: any[] = [];
    clientIds: any[] = [];
    siteIds: any[] = [];
}


export class InteractionHowModel {
    siteId?: number;
    value: number;
    pastValue: number;
    message: string;
    supplyTarrifType: string;
    friendlyDisconnect: SetBulkFriendlyDisconnect;
}

export enum MultiDeviceInteractionState {
    what = "what",
    when = "when",
    how = "how",
    who = "who",
    summary = "summary"
}

export class SetBulkFriendlyDisconnect {
    serialNumber: string;
    userID: string;
    specialDays: any[] = [];
    weekdays: boolean;
    weekdayStartTime: string;
    weekdayEndTime: string;
    saturday: boolean;
    saturdayStartTime: string;
    saturdayEndTime: string;
    sunday: boolean;
    sundayStartTime: string;
    sundayEndTime: string;
}

export class BulkFriendlyRequest {
    consumerIds: number[];
    bulkId: string;
    scheduleTime: Date;
    specialDays: Date[];
    weekdays: Days;
    saturday: Days;
    sunday: Days;
}

export class Days {
    disconnection_allowed: boolean;
    earliest_time: number;
    latest_time: number;
}

export class SetFriendlyDisconnect {
    SerialNumber: string;
    ScheduleTime: Date;
    BulkID: string;
    UserID: string;
    SpecialDays: string;
    Weekdays: string;
    Saturday: string;
    Sunday: string;
}

export class MultiDeviceInteractionModel {
    state: MultiDeviceInteractionState;
    what: InteractionTypeModel | null;
    when: InteractionDateModel | null;
    how: InteractionHowModel | null;
    who: InteractionWhoModel | null;
}
